module.exports = __webpack_public_path__ + "static/media/cash_blue.4151a4e4.svg";